// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceNotificationsResource extends Resource {
    basePath: string = 'services/notifications/';

    objectPath: string = 'services/notifications/{ident}/';
}
